var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7234 10.3482V8.51855C10.7234 8.20762 10.4719 7.95605 10.1609 7.95605C9.84999 7.95605 9.59842 8.20762 9.59842 8.51855V10.0982H2.13593V2.63574H9.59842V4.17949C9.59842 4.49043 9.84999 4.74199 10.1609 4.74199C10.4719 4.74199 10.7234 4.49043 10.7234 4.17949V2.38574C10.7234 1.90293 10.3312 1.51074 9.84842 1.51074H1.88593C1.40311 1.51074 1.01093 1.90293 1.01093 2.38574V10.3482C1.01093 10.8311 1.40311 11.2232 1.88593 11.2232H9.84842C10.3312 11.2232 10.7234 10.8311 10.7234 10.3482Z",
    fill: "#626262"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1219 5.77832H6.15936C5.67655 5.77832 5.28436 6.17051 5.28436 6.65332V8.49707C5.28436 8.80801 5.53593 9.05957 5.84686 9.05957C6.1578 9.05957 6.40936 8.80801 6.40936 8.49707V6.90332H13.8719V14.3658H6.40936V12.7596C6.40936 12.4486 6.1578 12.1971 5.84686 12.1971C5.53593 12.1971 5.28436 12.4486 5.28436 12.7596V14.6143C5.28436 15.0971 5.67655 15.4893 6.15936 15.4893H14.1219C14.6047 15.4893 14.9969 15.0971 14.9969 14.6143V6.65332C14.9969 6.17051 14.6047 5.77832 14.1219 5.77832Z",
    fill: "#626262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.9d809d78938556047016d1da75d66fca.svg";
export { ForwardRef as ReactComponent };